import { Record, RecordOf } from 'immutable';

import { Action } from 'redux/types';
import { Type } from './action-types';

export type CanvaPostMessageData = {
  tokenInfo: {
    accessToken: string;
    idToken: string;
    provider: 'canva';
    providerUserId: string;
  };
};

export type CanvaAuthData = Pick<
  CanvaPostMessageData['tokenInfo'],
  'accessToken' | 'idToken' | 'providerUserId'
>;

type State = CanvaAuthData & {
  isCreatingDesign: boolean;
  isDesignInProgress: boolean;
  isExportingDesign: boolean;
};

export type CanvaState = RecordOf<State>;

export const canvaStateFactory = Record<State>({
  accessToken: undefined,
  idToken: undefined,
  providerUserId: undefined,
  isCreatingDesign: false,
  isDesignInProgress: false,
  isExportingDesign: false,
});

export type CanvaAuthorizeSuccessAction = Action<
  Type.CANVA_AUTHORIZE_SUCCESS,
  CanvaAuthData
>;

type ClearCanvaUserAction = Action<Type.CANVA_USER_CLEAR>;

export type CreateCanvaDesignRequestAction = Action<
  Type.CREATE_CANVA_DESIGN_REQUEST
>;
export type CreateCanvaDesignSuccessAction = Action<
  Type.CREATE_CANVA_DESIGN_SUCCESS
>;
export type CreateCanvaDesignFailureAction = Action<
  Type.CREATE_CANVA_DESIGN_FAILURE
>;

export type ClearCanvaDesignInProgressAction = Action<
  Type.CLEAR_CANVA_DESIGN_IN_PROGRESS
>;

export type ExportCanvaDesignRequestAction = Action<
  Type.EXPORT_CANVA_DESIGN_REQUEST
>;
export type ExportCanvaDesignSuccessAction = Action<
  Type.EXPORT_CANVA_DESIGN_SUCCESS
>;
export type ExportCanvaDesignFailureAction = Action<
  Type.EXPORT_CANVA_DESIGN_FAILURE
>;

export type CanvaAction =
  | CanvaAuthorizeSuccessAction
  | ClearCanvaUserAction
  | CreateCanvaDesignRequestAction
  | CreateCanvaDesignSuccessAction
  | CreateCanvaDesignFailureAction
  | ClearCanvaDesignInProgressAction
  | ExportCanvaDesignRequestAction
  | ExportCanvaDesignSuccessAction
  | ExportCanvaDesignFailureAction;
